import { useState } from 'react'
import { Globe, KeyRound, Shield } from 'lucide-react'

interface CredentialRequestCardProps {
  data: {
    profileId?: string
    systemName: string
    domain: string
    loginUrl?: string
  }
  onSubmit?: (credentials: { username: string; password: string }) => void
}

export function CredentialRequestCard({ data, onSubmit }: CredentialRequestCardProps) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = () => {
    if (!username.trim() || !password.trim()) return
    onSubmit?.({ username: username.trim(), password: password.trim() })
  }

  return (
    <div className="automation-card" style={{ marginTop: 12 }}>
      <div className="automation-card-header">
        <div>
          <span className="automation-card-badge">
            <Shield size={12} />
            Sikker innlogging
          </span>
          <div className="automation-card-title">Logg inn på {data.systemName}</div>
        </div>
        <Globe size={16} style={{ color: '#7d7d7d', flexShrink: 0 }} />
      </div>

      <p className="automation-card-desc">
        Legg inn brukernavn og passord for {data.domain}. Dette lagres i denne Studio-chatten og brukes til å fortsette kartleggingen automatisk.
      </p>

      {data.loginUrl && (
        <div className="automation-card-field">
          <span className="automation-card-label">Login-URL</span>
          <span className="automation-card-value">{data.loginUrl}</span>
        </div>
      )}

      <div className="studio-memory-form" style={{ marginTop: 12 }}>
        <input
          className="studio-input"
          placeholder="Brukernavn"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="username"
        />
        <input
          className="studio-input"
          type="password"
          placeholder="Passord"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />
      </div>

      <div className="automation-card-actions">
        <button className="automation-card-btn automation-card-btn-primary" onClick={handleSubmit}>
          <KeyRound size={13} style={{ marginRight: 6, verticalAlign: 'text-bottom' }} />
          Lagre og fortsett
        </button>
      </div>
    </div>
  )
}
